import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RViewWithActionov1gis5vq13n as RViewWithAction } from '../RView.mjs';
import { vpropka48um9uweps as vprop } from './helpers.commonHtml.mjs';
import {
  KeyboardHints3coyq4x1rsbe3 as KeyboardHints,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
} from '../../models/data.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KeyCodes_instancevfnkc2xsbiba as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import { applyKeyboardHints2y8fo0b5cldu1 as applyKeyboardHints } from './KeyboardHints.ext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function TextInput$content$lambda($this$vprop) {
  // Inline function 'com.lightningkite.kiteui.views.valueString' call
  var tmp = $this$vprop.bb4_1.kb7_1.value;
  var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function TextInput$content$lambda_0($this$vprop, it) {
  // Inline function 'com.lightningkite.kiteui.views.valueString' call
  $this$vprop.bb4_1.kb7_1.value = it;
  return Unit_instance;
}
var TextInputClass;
function TextInput() {
  if (TextInputClass === VOID) {
    class $ extends RViewWithAction() {
      constructor(context) {
        super(context);
        this.vb5_1.zb3_1 = 'input';
        this.vb5_1.jb4_1.v('editable');
        var tmp = this;
        var tmp_0 = this.vb5_1;
        var tmp_1 = TextInput$content$lambda;
        tmp.icn_1 = vprop(tmp_0, 'input', tmp_1, TextInput$content$lambda_0);
        this.jcn_1 = new (KeyboardHints())();
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp_2;
        if (tmp0_safe_receiver == null) {
          tmp_2 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.iax()) {
              var tmp0_safe_receiver = this.mbg_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.zbe(this);
              }
            }
            return Unit_instance;
          });
          tmp_2 = Unit_instance;
        }
        if (tmp_2 == null) {
          // Inline function 'kotlin.run' call
          var tmp_3 = this_0.gb4_1['on' + 'keyup'];
          var old = (!(tmp_3 == null) ? typeof tmp_3 === 'function' : false) ? tmp_3 : null;
          var tmp_4 = 'on' + 'keyup';
          this_0.gb4_1[tmp_4] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.iax()) {
              var tmp0_safe_receiver_0 = this.mbg_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.zbe(this);
              }
            }
            return Unit_instance;
          };
        }
        this.kcn_1 = Align_Start_getInstance();
      }
      cbs(value) {
        this.jcn_1 = value;
        applyKeyboardHints(this.vb5_1, value);
      }
      dbs(value) {
        this.kcn_1 = value;
        var tmp0 = this.vb5_1.db4_1;
        var tmp;
        switch (value.b4_1) {
          case 0:
            tmp = 'start';
            break;
          case 1:
            tmp = 'center';
            break;
          case 2:
            tmp = 'end';
            break;
          case 3:
            tmp = 'justify';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        // Inline function 'com.lightningkite.kiteui.views.textAlign' call
        var value_0 = tmp;
        tmp0.hb7_1.textAlign = value_0;
      }
      ebs(value) {
        var tmp0 = this.vb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var value_0 = !value;
        tmp0.kb7_1.disabled = value_0;
      }
      fbs() {
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var tmp = this.vb5_1.bb4_1.kb7_1.disabled;
        var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null;
        return !(tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs);
      }
    }
    initMetadataForClass($, 'TextInput');
    TextInputClass = $;
  }
  return TextInputClass;
}
//region block: exports
export {
  TextInput as TextInput22lgsa81snd26,
};
//endregion

//# sourceMappingURL=TextField.commonHtml.mjs.map
